import React from "react";
import {
  View,
  ScrollView,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from "react-native";

import ImageComponent from "../../../common/ImageComponent";
import appStyles from "../../../../appStyles";
import AppTheme from "../../../AppTheme";
import integrationStyles from '../../onboarding/integrationStyles';
import {isWeb} from "../../../../../helpers/utils";

export default function DownloadStarted({ showAccounts = () => {} }) {
  return (
    <ScrollView
      style={(appStyles.scrollView, { paddingHorizontal: 16 })}
      contentContainerStyle={appStyles.scrollViewContent}
    >
      <Text style={styles.sectionText}>{isWeb ? "Desktop sync is downloading now" : "Please follow the download instructions in the email you received"}.</Text>

      <View
        style={{
          alignItems: "center",
          marginTop: 60,
          marginBottom: 35,
        }}
      >
        <ImageComponent
          image={require("../../../../../assets/integrations/desktopBig.png")}
          style={styles.desktopIcon}
        />
      </View>

      <Text style={styles.sectionText}>
        Please install as soon as possible for the best experience!
      </Text>

      <View style={[integrationStyles.buttons]}>
        <TouchableOpacity
          onPress={showAccounts}
          style={integrationStyles.greenButton}
        >
          <Text style={integrationStyles.greenButtonText}>Finish</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    marginTop: 32,
    textAlign: "center",
  },
  desktopIcon: {
    width: 279,
    height: 266,
  },
});
